export default "__VITE_ASSET__62aa2031__"